import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 80px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const OrgGridForm = styled.div`
  display: grid;
  grid-template-areas:
    "responsible_name responsible_name"
    "cep state"
    "neighbourhood city"
    "address address"
    "email phone"
    "role organization_type"
    "other_organization_type other_organization_type"
    "organization_area organization_area";
  gap: 20px;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
  `}
`;

export const DataGridForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
  `}
`;

export const Buttons = styled.div`
  padding-top: 40px;
  display: flex;
  justify-content: flex-end;
  gap: 20px;

  width: 100%;
`;

export const LocalGridForm = styled.div`
  width: 50%;
  padding-bottom: 20px;

  display: flex;
  flex-direction: column;
  gap: 20px;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;

    width: 100%;
  `}
`;

export const Uf = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Cities = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const City = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.white};

  display: flex;
  align-items: center;
  gap: 5px;
`;
